/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Faq_Q5Inputs */

const en_viewer_faq_q5 = /** @type {(inputs: Viewer_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I edit JSON in the viewer?`)
};

const ko_viewer_faq_q5 = /** @type {(inputs: Viewer_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`뷰어에서 JSON을 편집할 수 있나요?`)
};

const ja_viewer_faq_q5 = /** @type {(inputs: Viewer_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビューアーでJSONを編集できますか？`)
};

/**
* | output |
* | --- |
* | "Can I edit JSON in the viewer?" |
*
* @param {Viewer_Faq_Q5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_faq_q5 = /** @type {((inputs?: Viewer_Faq_Q5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Faq_Q5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_faq_q5(inputs)
	if (locale === "ko") return ko_viewer_faq_q5(inputs)
	return ja_viewer_faq_q5(inputs)
});